import { Navigate, Outlet } from 'react-router-dom';

import { Center, Loader, Text } from '@mantine/core';

import { requestErrorText } from '@/entities/ScudMapping/utils';

import { useScudMappingPermissions } from '@/shared/hooks/useScudMappingPermissions';

export const ScudMappingRoutes = () => {
	const { isAvailable, isPending, isError, error } = useScudMappingPermissions();

	if (isPending) {
		return (
			<Center h="50vh">
				<Loader />
			</Center>
		);
	}

	// Сервис недоступен (502/503) — объясняем, а не уводим на главную как пользователя без прав
	if (isError) {
		return (
			<Center h="50vh" px="md">
				<Text c="dimmed" ta="center">
					{requestErrorText(error, 'Не удалось проверить доступ к сопоставлению пропусков')}
				</Text>
			</Center>
		);
	}

	if (!isAvailable) {
		return <Navigate to={'/'} replace />;
	}

	return <Outlet />;
};
